module.exports = __webpack_public_path__ + "img/guileme-2.0b6feabc.png";